import { GridApi } from '@instinet-analytics/semantic-ui-components';
import {
    ColumnDefinitionsDictionary,
    ValueType,
} from '@instinet-analytics/semantic-ui-components';
import { IndigoAppContextType } from 'app/AppContext';
import { useEffect } from 'react';
import { ClientSideDynamicCols } from 'widgets/blotter/columns/ColumnPortfolio';
import { useLogger } from 'logging/writers/hooks';

export function useRefreshGridOnAppContextChange<TColumnId extends string>(
    gridApi: GridApi | undefined,
    columnDefinitions: ColumnDefinitionsDictionary<TColumnId>,
    visibleColumns: TColumnId[],
    appContext: IndigoAppContextType
) {
    const logger = useLogger('useRefreshGridOnAppContextChange');
    useEffect(() => {
        const colsToRefresh = [
            ...ClientSideDynamicCols,
            ...visibleColumns.filter(
                (c) => columnDefinitions[c].valueType === ValueType.CURRENCY
            ),
        ];
        if (gridApi) {
            logger.debug('Refreshing cells', colsToRefresh);
            gridApi.refreshCells({ columns: colsToRefresh, force: true });
        }
    }, [gridApi, columnDefinitions, visibleColumns, appContext, logger]);
}
